import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CompanyLayoutContext from "@/model/CompanyLayoutContext";
import "@/pages/CompanyOverviewTab/CompanyOverviewTab.scss";

function CompanyOverviewTab() {
  const { t } = useTranslation();
  const { company } = useOutletContext<CompanyLayoutContext>();

  return (
    <dl className="company-overview-tab">
      <dt>{t("companies.overview.fields.id")}</dt>
      <dd>{company.id ?? "—"}</dd>

      {company.registrationNumber && (
        <>
          <dt>{t("companies.overview.fields.registrationNumber")}</dt>
          <dd>{company.registrationNumber}</dd>
        </>
      )}

      <dt>{t("companies.overview.fields.email")}</dt>
      <dd>{company.email ?? "—"}</dd>

      {company.phoneNumber && (
        <>
          <dt>{t("companies.overview.fields.phoneNumber")}</dt>
          <dd>{company.phoneNumber}</dd>
        </>
      )}

      <dt>{t("companies.overview.fields.address")}</dt>
      <dd>
        {company.address
          ? [
              company.address.street,
              company.address.postalCode,
              company.address.city,
              company.address.country,
            ]
              .filter(Boolean)
              .join(", ") || "—"
          : "—"}
      </dd>

      {company.website && (
        <>
          <dt>{t("companies.overview.fields.website")}</dt>
          <dd>{company.website}</dd>
        </>
      )}

      {company.description && (
        <>
          <dt>{t("companies.overview.fields.description")}</dt>
          <dd>{company.description}</dd>
        </>
      )}

      {company.logoUrl && (
        <>
          <dt>{t("companies.overview.fields.logoUrl")}</dt>
          <dd>{company.logoUrl}</dd>
        </>
      )}

      <dt>{t("companies.overview.fields.createdAt")}</dt>
      <dd>
        {company.createdAt ? new Date(company.createdAt).toLocaleString() : "—"}
      </dd>

      <dt>{t("companies.overview.fields.updatedAt")}</dt>
      <dd>
        {company.updatedAt ? new Date(company.updatedAt).toLocaleString() : "—"}
      </dd>
    </dl>
  );
}

export default CompanyOverviewTab;
